var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.998 511.998",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EE8700"
    },
    d: "M398.053,29.722C359.718,10.556,309.27,0,255.998,0c-53.275,0-103.726,10.556-142.06,29.723 c-43.46,21.73-67.396,52.501-67.396,86.642v93.089v93.089v93.089c0,34.144,23.935,64.913,67.396,86.645 c38.332,19.167,88.785,29.722,142.06,29.722c53.272,0,103.721-10.556,142.057-29.722c43.465-21.732,67.402-52.502,67.402-86.645 v-93.089v-93.089v-93.089C465.455,82.224,441.518,51.453,398.053,29.722z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M255.998,372.358c93.238,0,162.906-36.858,162.906-69.813v-18.569 c-6.35,4.292-13.297,8.347-20.849,12.12c-38.335,19.168-88.786,29.723-142.057,29.723c-53.275,0-103.726-10.556-142.06-29.723 c-7.549-3.774-14.496-7.827-20.844-12.117v18.566C93.094,335.5,162.761,372.358,255.998,372.358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M255.998,186.178c93.238,0,162.906-36.858,162.906-69.813c0-32.954-69.669-69.813-162.906-69.813 S93.094,83.411,93.094,116.365C93.094,149.322,162.761,186.178,255.998,186.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M255.998,465.448c93.238,0,162.906-36.859,162.906-69.815v-18.569 c-6.35,4.294-13.297,8.347-20.849,12.124c-38.335,19.168-88.785,29.722-142.057,29.722c-53.275,0-103.728-10.555-142.06-29.722 c-7.549-3.775-14.496-7.828-20.844-12.12v18.566C93.094,428.589,162.761,465.448,255.998,465.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB655"
    },
    d: "M255.998,279.269c93.238,0,162.906-36.858,162.906-69.813v-18.569 c-6.35,4.292-13.297,8.347-20.849,12.122c-38.335,19.167-88.786,29.722-142.057,29.722c-53.275,0-103.726-10.556-142.06-29.722 c-7.549-3.777-14.496-7.828-20.844-12.119v18.566C93.094,242.411,162.761,279.269,255.998,279.269z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.329f844aeffca570f4a35a6a69bfa59d.svg";
export { ForwardRef as ReactComponent };